import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/shift-work";

export const pagingShiftWork = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getShiftWorkById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = shiftWork => axios.post(API_PATH + '/save', shiftWork);

export const deleteShiftWork = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllShiftWorks = () => axios.get(API_PATH + "/get-all");

export const generateWorkingSlot = (shiftWorkId,numberOfSlot,startSlotNumber) => {
     const url = `${API_PATH}/generate-working-slot/${shiftWorkId}/${numberOfSlot}/${startSlotNumber}`;
     return axios.get(url);
   };